import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NotificationComponent } from './notification.component';
import { IconComponent } from '../icon/icon.component';

@NgModule({
  declarations: [NotificationComponent],
  imports: [CommonModule, IconComponent],
  exports: [NotificationComponent],
})
export class NotificationModule {}
